import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=2a581157&scoped=true"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"
import style0 from "./Progress.vue?vue&type=style&index=0&id=2a581157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a581157",
  null
  
)

export default component.exports